import {SegmentModeEnum} from "./SegmentModeEnum";
import {generateUUID} from "../../../services/misc";

export type KeyboardVisibility = {
  isVisibleForSegmentsWithNotationOnly: boolean;
  isVisibleForSegmentsWithVideoOnly: boolean;
  isVisibleForSegmentsWithBothVideoAndNotation: boolean;
};

/**
 * LessonPlayerSettings represents the state of various components on the lesson page.
 * e.g. show/hide the fretboard, chord charts, zoom level, etc.
 *
 * @deprecated This may not make sense since it is only under a variable called segment.
 * Consider moving all this stuff elsewhere.
 */
export default class LessonPlayerSettings {
  chordDiagramsVisible: boolean;
  chordNamesVisible: boolean;
  displayRhythmCounts: boolean;
  forceSideVideo: boolean;
  forceTopVideo: boolean;
  guid: string;
  horizontalScrollPlayheadFixedEnabled: boolean;
  keyboard: KeyboardVisibility;
  noteNamesVisible: boolean;
  sideVideoWidthPercent: number;
  staffFingeringsVisible: boolean;
  staffNotationVisible: boolean;
  topVideoHeightPercent: number;
  constructor({
    chordDiagramsVisible,
    chordNamesVisible,
    displayRhythmCounts,
    forceSideVideo,
    forceTopVideo,
    guid,
    horizontalScrollPlayheadFixedEnabled,
    keyboard,
    noteNamesVisible,
    sideVideoWidthPercent,
    staffFingeringsVisible,
    staffNotationVisible,
    topVideoHeightPercent,
  }: LessonPlayerSettings = {
    chordDiagramsVisible: false,
    chordNamesVisible: false,
    displayRhythmCounts: false,
    forceSideVideo: false,
    forceTopVideo: true,
    guid: generateUUID(),
    horizontalScrollPlayheadFixedEnabled: true,
    keyboard: {
      isVisibleForSegmentsWithNotationOnly: false,
      isVisibleForSegmentsWithVideoOnly: false,
      isVisibleForSegmentsWithBothVideoAndNotation: false,
    },
    noteNamesVisible: false,
    sideVideoWidthPercent: 0,
    staffFingeringsVisible: false,
    staffNotationVisible: false,
    topVideoHeightPercent: 0,
  }) {
    Object.assign(this, {
      chordDiagramsVisible,
      chordNamesVisible,
      displayRhythmCounts,
      forceSideVideo,
      forceTopVideo,
      guid,
      horizontalScrollPlayheadFixedEnabled,
      keyboard,
      noteNamesVisible,
      sideVideoWidthPercent,
      staffFingeringsVisible,
      staffNotationVisible,
      topVideoHeightPercent,
    });
  }
}

export function getKeyboardVisibilityPropertyAssociatedWithSegmentMode(mode: SegmentModeEnum): keyof KeyboardVisibility {
  switch(mode) {
    case SegmentModeEnum.followAlong:
      return "isVisibleForSegmentsWithBothVideoAndNotation";
    case SegmentModeEnum.play:
      return "isVisibleForSegmentsWithVideoOnly";
    default:
      return "isVisibleForSegmentsWithNotationOnly";
  }
}

export function isBirdsEyeKeyboardVisible(lessonPlayerSettings: LessonPlayerSettings, mode: SegmentModeEnum): boolean {
  const property = getKeyboardVisibilityPropertyAssociatedWithSegmentMode(mode);
  return lessonPlayerSettings.keyboard[property];
}